import { useAuthProvider } from "../Providers/AuthProvider"

export function useDataReviewPermissions() {
	const authProvider = useAuthProvider()
	const canViewDataReview = authProvider.permissions?.['data_review:view'] as boolean | undefined
	const canManageDataReview = authProvider.permissions?.['data_review:manage'] as boolean | undefined
	const canShareDataReview = authProvider.permissions?.['data_review:share'] as boolean | undefined

	/** Returns the appropriate permission for editing a group based on whether it is personal or shared. */
	const canEditGroup = (groupType?: string) =>
		groupType?.toLowerCase() === 'personal' ? canManageDataReview : canShareDataReview

	return { canViewDataReview, canManageDataReview, canShareDataReview, canEditGroup }
}
